export default __webpack_public_path__ + "static/media/logo.6dab05b3.jpg";